import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeSeasonList = (data) => {
	return {
		type: Types.STORE_SEASON_LIST,
		payload: data
	};
};

export const fetchSeasonList =
	(params = 'info.nitex.app.materials.Season') =>
	async (dispatch) => {
		await ApiClient.GET('getEnums', params).then((response) => {
			dispatch(storeSeasonList(response.data));
		});
	};
